import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Item\GetItemByIdController::__invoke
* @see app/Http/Controllers/Item/GetItemByIdController.php
* @route '/api/item/{item}'
*/
const GetItemByIdController = (args: { item: string | { id: string } } | [item: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetItemByIdController.url(args, options),
    method: 'get',
})

GetItemByIdController.definition = {
    methods: ["get","head"],
    url: '/api/item/{item}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Item\GetItemByIdController::__invoke
* @see app/Http/Controllers/Item/GetItemByIdController.php
* @route '/api/item/{item}'
*/
GetItemByIdController.url = (args: { item: string | { id: string } } | [item: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { item: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { item: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            item: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        item: typeof args.item === 'object'
        ? args.item.id
        : args.item,
    }

    return GetItemByIdController.definition.url
            .replace('{item}', parsedArgs.item.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Item\GetItemByIdController::__invoke
* @see app/Http/Controllers/Item/GetItemByIdController.php
* @route '/api/item/{item}'
*/
GetItemByIdController.get = (args: { item: string | { id: string } } | [item: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetItemByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Item\GetItemByIdController::__invoke
* @see app/Http/Controllers/Item/GetItemByIdController.php
* @route '/api/item/{item}'
*/
GetItemByIdController.head = (args: { item: string | { id: string } } | [item: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetItemByIdController.url(args, options),
    method: 'head',
})

export default GetItemByIdController